
/**
 * Default toast configuration to ensure consistent behavior
 * across the entire application.
 */
export const defaultToastConfig = {
  duration: 2000, // 2 seconds duration for all toast notifications
  position: 'top-right' as const,
  closeButton: true,
};

export const configureToast = (options = {}) => {
  return {
    ...defaultToastConfig,
    ...options,
  };
};
